//#region src/utils/get-array-difference-by.ts
function e(e, t, n) {
	let r = e.map(n), i = t.map(n);
	return {
		added: t.filter((e) => !r.includes(n(e))),
		removed: e.filter((e) => !i.includes(n(e)))
	};
}
//#endregion
export { e as getArrayDifferenceBy };
